export default __webpack_public_path__ + "static/media/shuju_w.daa8ce88.png";